<script lang="ts">
  import { selectedDeviceType } from '$lib/PersistedState.svelte';
  import { getDeviceConfig } from '$lib/devices/registry';
  import type { Component } from 'svelte';

  let SettingsComponent: Component | null = $state(null);
  let loading = $state(false);

  $effect(() => {
    const loadComponent = async () => {
      const config = getDeviceConfig(selectedDeviceType.value);

      if (config.settingsComponent) {
        loading = true;
        try {
          const module = await config.settingsComponent();
          SettingsComponent = module.default;
        } catch (error) {
          console.error('Failed to load device settings component:', error);
          SettingsComponent = null;
        } finally {
          loading = false;
        }
      } else {
        SettingsComponent = null;
      }
    };

    loadComponent();
  });
</script>

{#if loading}
  <div class="animate-pulse">Loading device settings...</div>
{:else if SettingsComponent}
  <SettingsComponent />
{/if}
